<template>  
<div class="grid-container">
  <Menu  @customChange="menuOpenHandler" :scrollDisable="scrollDisable" class="" />
  <About/>
  <HeroMedium class="grid-hero" :title="'Assessment Activities'" />
  <router-view class="grid-main section-margin-top" />
  <Footer/>
</div>
</template>

<script>
import Menu from '@/components/Menu'
import HeroMedium from '@/components/HeroMedium'
import About from '@/components/About'
import Footer from '@/components/Footer'
import { ref } from 'vue' 

export default {
  components: { Menu, HeroMedium, Footer, About },

  setup() {

      const scrollDisable = ref(false)

      const menuOpenHandler = () => {
        scrollDisable.value = !scrollDisable.value

        if(scrollDisable.value === true) {
          // document.querySelector("body").style.height = '100%';
              document.querySelector("body").style.overflowY = 'hidden';

        } else {
          // document.querySelector("body").style.height = 'auto';
              document.querySelector("body").style.overflowY = 'visible';
              document.querySelector("body").style.overflowY = 'scroll';
        }

      }


    return { menuOpenHandler, scrollDisable }

    // return { noneScroll, scrollDisable }
  }
}
</script>


<style lang="scss">

.noScroll {
overflow: hidden;
position: absolute;
height: 100vh;
}


</style>
